import React from 'react'
import NavBar from '../components/Home/NavBar'
import RenovacionDdjjForm from '../components/Forms/DeclaracionJurada/RenovacionDdjjForm'

const RenovacionDDJJ = () => {
  return (
    <div>
      <NavBar />
      <RenovacionDdjjForm />
    </div>
  )
}

export default RenovacionDDJJ